import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import React from "react";
import { useTranslation } from "react-i18next";
import { TRANSACTION_TYPE_PAYMENT, TRANSACTION_TYPE_PAYOUT } from "../../../../utils/consts";

const TransactionType = ({
  checkedTransactionType,
  setCheckedTransactionType,
  direction,
  defaultOption = false,
  label = "Transaction Type",
  error = null,
  refField= null
}) => {
  const { t } = useTranslation("otherInterface");

  const handleChangeSelect = (e) => {
    let data = e.target.value;
    setCheckedTransactionType(data);
  };

  const transactionTypes = direction === 'payments'
    ? TRANSACTION_TYPE_PAYMENT
    : TRANSACTION_TYPE_PAYOUT;

  return (
    <>
      <FormControl error={error} ref={refField}>
        <InputLabel id="transaction-type-select-label">{label === "Transaction Type" && t("transactionType.title")}</InputLabel>
        {/* No need to change on Autocomplete component (few options) */}
        <Select
          labelId="transaction-type-select-label"
          id="transaction-type-select"
          value={checkedTransactionType ?? transactionTypes.ORDER}
          onChange={handleChangeSelect}
        >
          {defaultOption && <MenuItem value={null}>All</MenuItem>}
          {Object.entries(transactionTypes).map(([key, value]) => (
            <MenuItem key={key} value={value}>
              {value}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
};

export default TransactionType;